import http from '@/communication/AuthConnection'

export default async ({ commit }, documentId) => {
  try {
    const { data } = await http.delete(`/v1/document-type/${documentId}`)
    return data
  } catch (error) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/document-type/remove-register/index.js